export default __webpack_public_path__ + "static/media/Desktop-ModelX.95984d50.jpg";